import React, { FC } from 'react';
import { ScannerCase, ScanSource } from 'models/scanner-case';
import ScannerCasePreviewImages from './scanner-case-preview-images/scanner-case-preview-images.component';
import ThreeShapeJawPreview from './three-shape-jaw-preview/three-shape-jaw-preview.component';
import DsCorePreview from './ds-core-preview/ds-core-preview.component';

type ScannerCasePreviewProps = {
    scannerCase: ScannerCase;
    height?: number;
    cols?: number;
};
const ScannerCasePreview: FC<ScannerCasePreviewProps> = ({ scannerCase, height, cols }) => {
    return (
        <>
            {scannerCase && scannerCase.previewImages.length > 0 ? (
                <ScannerCasePreviewImages scannerCase={scannerCase} height={height} cols={cols} />
            ) : (
                <>
                    {scannerCase && scannerCase.source === ScanSource.THREE_SHAPE ? (
                        <ThreeShapeJawPreview scannerCase={scannerCase} height={height} cols={cols} />
                    ) : undefined}
                    {scannerCase && scannerCase.source === ScanSource.DS_CORE ? (
                        <DsCorePreview scannerCase={scannerCase} height={height} cols={cols} />
                    ) : undefined}
                </>
            )}
        </>
    );
};

export default ScannerCasePreview;
